import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../utils/Config';
function useCoverLetter(token, apiCandidateID) {
    const [coverLetter, setCoverLetter] = useState(null);
    const baseUrl = getApiBaseUrl();

    useEffect(() => {
        if (token && apiCandidateID) {
            const fetchCover = async () => {
                try {
                    const response = await fetch(
                        `${baseUrl}/api/Attachment/GetCandidateCoverLetter?candidateId=${apiCandidateID}`,
                        {
                            mode: 'cors',
                            headers: {
                                "Authorization": `Bearer ${token}`
                            }
                        }
                    );
                    const data = await response.json();
                    setCoverLetter(data.result);

                } catch (error) {
                    console.error("Failed to fetch cover letter URL:", error);
                }
            };

            fetchCover();
        }
    }, [token, apiCandidateID, baseUrl]);

    return coverLetter;  
}

export default useCoverLetter;
